import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const ScrollBarTitle = styled.label`
  ${(props) =>
    props.$cco
      ? `
        padding: 18px var(--cco-pad) 10px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: var(--cco-blue);
      `
      : `
        font-size: 16px;
        font-weight: 800;
        margin-bottom: 10px;
        color: ${props.theme.colors.darkblue};
      `}
`;

export const ListLabel = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  background: transparent;
  font-family: inherit;

  ${(props) =>
    props.$cco
      ? `
        padding: 14px var(--cco-pad);
        gap: 10px;
        border: none;
        border-top: 1px solid var(--cco-line);
        border-radius: 0;
        font-size: 14px;
        font-weight: 500;
        color: ${props.selected ? 'var(--cco-blue)' : 'var(--cco-ink)'};
        transition: background 120ms, color 120ms;

        /* Seletor descendant (sem '>') porque o JSX envolve count/chev
           num span inline-flex wrapper, entao sao GRANDFILHOS. */
        /* Pill neutro pro total de parques. Visual parelho ao alert-count
           mas em tom mute pra nao competir — operador identifica que e
           o mesmo 'tipo' de chip (numero contextual) mas com semantica
           informativa (vs alerta). */
        .count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 22px;
          height: 18px;
          padding: 0 6px;
          border-radius: 9px;
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid var(--cco-line);
          color: var(--cco-ink-mute);
          font-variant-numeric: tabular-nums;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: -0.1px;
        }
        /* Pills por tipo de equipamento — laranja UCHA / azul EBA
           (convencao do app). Mesmo formato do .count. */
        .count-ucha,
        .count-eba {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 22px;
          height: 18px;
          padding: 0 6px;
          border-radius: 9px;
          font-variant-numeric: tabular-nums;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: -0.1px;
        }
        .count-ucha {
          background: var(--cco-orange-soft);
          border: 1px solid var(--cco-orange);
          color: var(--cco-orange);
        }
        .count-eba {
          background: var(--cco-blue-soft);
          border: 1px solid var(--cco-blue);
          color: var(--cco-blue);
        }
        /* Badge de parques em alerta — vermelho, com tint sutil pra
           dar peso visual sem agredir. So aparece quando > 0 (visivel
           = ha algo pra ver). */
        .alert-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 22px;
          height: 18px;
          padding: 0 6px;
          border-radius: 9px;
          background: rgba(232, 65, 65, 0.16);
          border: 1px solid rgba(232, 65, 65, 0.32);
          color: var(--cco-red);
          font-variant-numeric: tabular-nums;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: -0.1px;
        }
        .chev {
          display: inline-flex;
          color: var(--cco-ink-faint);
          flex-shrink: 0;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.025);
        }
      `
      : `
        padding: 4px 10px;
        margin: 0px 4px 8px 0px;
        font-size: 13px;
        font-weight: 700;
        transition: all 270ms;
        border: none;
        border-radius: 6px;
        ${
          props.selected
            ? `background: ${props.theme.colors.blue}; color: ${props.theme.colors.white};`
            : ''
        }
        @media (max-width: 1300px) {
          width: 160px;
        }
        &:hover {
          background: ${props.theme.colors.blue};
          color: ${props.theme.colors.white};
        }
        &::after {
          content: 'X';
          color: ${props.selected ? 'white' : 'transparent'};
          font-size: 10px;
          margin-left: auto;
          position: absolute;
          right: 3px;
          top: 3px;
        }
        &:last-child {
          margin-bottom: 0px;
        }
      `}
`;

export const Empty = styled.label`
  font-size: 12px;
  color: ${(props) => props.theme.colors.label};
  font-style: italic;
  align-self: center;
`;

export const ZoneScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;

  ${(props) =>
    props.$cco
      ? `
        flex: 1;
        max-height: none;
        height: auto;
      `
      : `
        height: calc(100% - 65px);
        max-height: 300px;

        ::-webkit-scrollbar-track {
          border-radius: 6px;
          background-color: ${
            props.theme.title === 'light'
              ? props.theme.colors.lightergrey
              : props.theme.colors.darker
          };
        }
        ::-webkit-scrollbar {
          width: 6px;
          background-color: ${
            props.theme.title === 'light'
              ? props.theme.colors.lightergrey
              : props.theme.colors.darker
          };
          border-radius: 6px;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 6px;
          background-color: ${props.theme.colors.label};
        }
      `}
`;
